import { sortBy } from 'lodash';

export const sortLowerCase = (array: string[]) => {
  return sortBy(array, x => x.toLowerCase());
};
